module.exports = __webpack_public_path__ + "static/media/dcsLogo.e3a410d5.png";